<template>
  <div>
    <div class="wrap">
      <div class="statement" style="text-align: center;">
        <div>We've Recommitted<br/>To Our Customers</div>
        <div class="count">{{formatNum(count)}}</div>
        <div>Times</div>
        <div class="logo"><img src="https://useproof.s3.amazonaws.com/turbo1/logo-primary.svg" height="50" /></div>
      </div>
    </div>
    <canvas class="confetti" ref="confetti"></canvas>
  </div>
</template>

<script>
import confetti from './confetti'
const firebase = window.firebase
export default {
  name: 'count',
  data () {
    return {
      count: 0
    }
  },
  methods: {
    formatNum (x) {
      if (!x) return '0'
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  mounted () {
    // bind to firebase endpoint to get count from server
    firebase.database().ref('btnCount/count').on('value', snap => {
      this.count = snap.val()
    })

    // listen for keypress to update count instantly
    document.onkeypress = (e) => {
      if (e.key === 'i') {
        this.count++
      }
    }
  },
  watch: {
    count () {
      if (Math.floor(Math.random() * 20) === 0) {
        confetti.initialize(this.$refs.confetti, 5)
      }
    }
  }
}
</script>

<style lang="scss">
.wrap {
  padding-top: 50px;
}
.statement {
  color: #2b3950;
  font-size: 75px;

  .count {
    color: #0095f7;
    font-size: 200px;
  }
}

.logo {
  margin-top: 200px
}
.confetti {
  left: 0;
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Count/index.vue